// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"632":"5562231b","921":"5562231b"}[chunkId] + ".chunk.css";
};